require('./brokerInternalTransferFundsStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const Immutable = require('immutable');
const classNames = require('classnames');

// @commons
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const { AmountInput } = require('commonsComponents/amountInput');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const DropdownFunds = require('components/broker/brokerDropdownFunds/dropdownFunds.js');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKLink } = require('commonsComponents/OKLink');

// @helpers
const { getFormattedString, formatAmount } = require('utilities/currencyHelper');
import { recordLinkV2 } from "utilities/tagging";
import {
    brokerTransferFundsTags
}  from 'utilities/taggingInfo/brokerTransferFundsTags';
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const IbanHelper = require('utilities/ibanHelper');

// @constants
const {
  BROKER_FUNDS_AMOUNT_DECIMALS,
  BROKER_FUNDS_PARTICIPATIONS_DECIMALS,
  BROKER_FUNDS_PERCENTAGE_DECIMALS,
  BROKER_REIMBURSE_FUND_TOTAL,
  BROKER_REIMBURSE_FUND_PARTIAL,
  BROKER_FUNDS_INTERNAL_TRANSFER_AMOUNT_MINIMUM_VALUE,
  BROKER_FUNDS_INTERNAL_TRANSFER_AMOUNT_MAXIMUM_VALUE,
  BROKER_FUNDS_INTERNAL_TRANSFER_AMOUNT_INTEGER_LENGTH,
  BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT,
  BROKER_FUNDS_INTERNAL_TRANSFER_PARTICIPATIONS_INTEGER_LENGTH,
  BROKER_FUNDS_INTERNAL_TRANSFER_PARTICIPATIONS_MINIMUM_VALUE,
  BROKER_FUNDS_INTERNAL_TRANSFER_PARTICIPATIONS_MAXIMUM_VALUE,
  BROKER_FUNDS_INTERNAL_TRANSFER_PERCENTAGE_MINIMUM_VALUE,
  BROKER_FUNDS_INTERNAL_TRANSFER_PERCENTAGE_MAXIMUM_VALUE,
  BROKER_FUNDS_INTERNAL_TRANSFER_PERCENTAGE_INTEGER_LENGTH,
  BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT,
  BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS,
  BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE,
  EURO_TEXT,
  API_ENTERPRISE_NUMBER,
  API_CENTER,
  FIRST_STEP,
  BROKER_INTERNAL_TRANSFER_NEW_FUND,
  BROKER_INTERNAL_TRANSFER_EXISTING_FUND,
  SHOW_AMOUNT_AND_PERCENTAGE_RADIO_BUTTON,
  SHOW_PARTICIPATIONS_RADIO_BUTTON
} = require('constants/index');

class BrokerInternalTransferFundsStep1 extends React.Component {

  constructor(props) {
    super(props);
    this.setAmount = this.setAmount.bind(this);
    this.onChangeAmount = this.onChangeAmount.bind(this);
  }

  componentWillMount() {
    const { immBrokerInternalTransferFunds, immBrokerMyInvestments } = this.props;

    if (immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'displayMifidDisclaimer'])) {
      const mifidId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'mifidId']);
      this.props.onFetchBrokerMiFIDProduct(mifidId);
    }

        const destinationFundId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);
    const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);

    let fundId;
        if  (fundType === BROKER_INTERNAL_TRANSFER_NEW_FUND) {
      fundId = destinationFundId;
    } else {
      const funds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
      const destinationFund = funds.find(f => f.get('id') === destinationFundId);
      fundId = destinationFund.get('customInstitutionSecurityId');
    }

    this.props.getMorningStarScreener(fundId);
  }

  onChangeAmount(value, partialType) {
    if (partialType === 'participations') {
      const { immBrokerInternalTransferFunds } = this.props;
      const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
      const originFundCurrency = immBrokerInternalTransferFunds.getIn([
        'steps',
        FIRST_STEP,
        'originFundCurrency',
      ]);
      this.props.onSetAmount(value, partialType);
      this.props.setAproxAmountParticipations(value);
    }
  }

  setAmount(value, partialType) {
    const { immBrokerInternalTransferFunds } = this.props;
    const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
        const originFundCurrency = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFundCurrency']);
    this.props.onSetAmount(value, partialType);
    recordLinkV2({
            ...brokerTransferFundsTags(fundType, partialType, value, originFundCurrency)
        })
  }

  buildDestinationFundContainer() {
        const { immBrokerInternalTransferFunds, handleSetDestinationFund, immDestinationFunds } = this.props;
    const fundId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);
        const destinationFundValid = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFundValid']);
    const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
    if (fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
      return (
        <div className="broker-internal-transfer-funds-step1__dropdown-container">
          <DropdownFunds
            id="broker-destination-funds"
            immFunds={immDestinationFunds}
            currentFundId={fundId}
            onFundChange={handleSetDestinationFund}
            error={!destinationFundValid}
            errorMsg={formatText('broker-internalTransferFundEmptyToAccountError')}
            enabled={false}
          />
        </div>
            )
    } else if (fundType === BROKER_INTERNAL_TRANSFER_NEW_FUND) {
            const fundISIN = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundISIN']);
            const fundName = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFundName']);
      return (
        <div className="broker-internal-transfer-funds-step1__new-fund broker-internal-transfer-funds-step1__dropdown-container">
                    <div className="broker-internal-transfer-funds-step1__new-fund-name">
                        {fundName}
                    </div>
          <div className="broker-internal-transfer-funds-step1__new-fund-isin">
            {formatText('brokerHireInvestmentStep1-isin')}: {fundISIN}
          </div>
        </div>
            )
    }
  }

  buildDetails(fund) {
        const { immBrokerMyInvestments, immBrokerInternalTransferFunds, immFunds, immAccounts } = this.props;
        const fundId  = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, fund]);
        const destinationFund = fundId ? fundId : immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'selectedNewFund']);
    let selectedFund;
    let fundDetails;

    if (destinationFund) {
            const funds = immBrokerMyInvestments.getIn(['products','funds','stocks'], Immutable.fromJS({}));
      selectedFund = funds.find(fund => fund.get('id') === destinationFund);
    }

    if (selectedFund) {
            fundDetails = immFunds.find(fund =>
                fund.getIn(['contrato','producto']) === selectedFund.get('product') &&
                fund.getIn(['contrato','numerodecontrato']) === selectedFund.get('numerodecontrato')
      );
    }

    if (fundDetails) {
      const contractNumber = formatText('brokerInternalTransferFund-contractNumber');
      const account = formatText('brokerInternalTransferFund-account');
      const participationsText = formatText('brokerInternalTransferFund-participations');
      const holder = formatText('brokerInternalTransferFund-holder');
      const balance = formatText('brokerInternalTransferFund-balance');
      const availableText = formatText('brokerInternalTransferFund-available');

            const contractNumberValue= fundDetails.getIn(['contrato', 'numerodecontrato']) || '';
      const productValue = fundDetails.getIn(['contrato', 'producto']) || '';
      const fundControlDigit = selectedFund.get('controlDigit', '');
      const accountProduct = fundDetails.getIn(['cuentaAsociada', 'subgrupo']) || '';
      const accountContract = fundDetails.getIn(['cuentaAsociada', 'numerodecontrato']) || '';

            const immAccount = immAccounts.get('byId').find(account => account.get('product')===accountProduct && account.get('contractNumber')===accountContract);
      let balanceObject = {
        amount: 0,
                currency: EURO_TEXT
      };

      let accountControlDigit;
      if (immAccount) {
        balanceObject = {
          amount: immAccount.getIn(['balances', 'realBalance', 'amount']),
          currency: immAccount.getIn(['balances', 'realBalance', 'currency']),
                }
        accountControlDigit = immAccount.getIn(['ibanComplex', 'digitodecontrol'], '');
      }

      const balanceValue = getFormattedString(balanceObject);
      const prefix = `${API_ENTERPRISE_NUMBER}${API_CENTER}`;
      const fundcontract = IbanHelper.formatAccountTextWithSpaces(
        `${prefix}${fundControlDigit}${productValue}${contractNumberValue}`,
        BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT
      );
      const accountValue = IbanHelper.formatAccountTextWithSpaces(
        `${prefix}${accountControlDigit}${accountProduct}${accountContract}`,
        BROKER_FUNDS_INTERNAL_TRANSFER_CONTRACT_FORMAT
      );

            const contractRow = `${contractNumber}: ${fundcontract} (${holder}: ${fundDetails.get('nombretitular') || ''})`
            const accountRow = `${account}: ${accountValue} (${balance}: ${balanceValue})`

            const participations = formatAmount(fundDetails.get('participaciones'), null, BROKER_FUNDS_PARTICIPATIONS_DECIMALS);
            const available = formatAmount(fundDetails.get('disponible'), null, BROKER_FUNDS_PARTICIPATIONS_DECIMALS);

      const participationsRow = `${participationsText}: ${available} (${availableText}: ${participations})`;

      return (
        <div className="broker-internal-transfer-funds-step1__details-fund">
                    <div>
                        {contractRow}
                    </div>
                    <div>
                        {accountRow}
                    </div>
                    <div>
                        {participationsRow}
                    </div>
        </div>
      );
    }
  }

  buildMIFID() {
    const { immBrokerInternalTransferFunds, immBrokerMiFIDProducts } = this.props;

    if (immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'displayMifidDisclaimer'])) {
      const mifidId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'mifidId']);

      if (immBrokerMiFIDProducts.getIn(['products', mifidId, 'loading'])) {
                return <LoadingSection/>;
      } else {
        const mifidDisclaimer = immBrokerMiFIDProducts.getIn(['products', mifidId, 'disclaimer']);

        return (
          <div>
                        <FormattedText value="brokerHireInvestmentStep1-subTitle" className="broker-internal-transfer-funds-step1__subtitle"/>
            <p className="broker-internal-transfer-funds-step1__mifid-disclaimer">
              {mifidDisclaimer}
            </p>
          </div>
        );
      }
    }
  }

  buildOriginFoundContainer() {
    const { immBrokerMyInvestments, immBrokerInternalTransferFunds } = this.props;
        const immFunds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
    const fundId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFund']);
        const originFundValid = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFundValid']);

    if (immFunds && immFunds.size > 0) {
      return (
        <div className="broker-internal-transfer-funds-step1__dropdown-container">
          <DropdownFunds
            id="broker-stocks-contracts"
            immFunds={immFunds}
            currentFundId={fundId}
            onFundChange={this.props.handleOnOriginFundChange}
            error={!originFundValid}
            errorMsg={formatText('broker-internalTransferFundEmptyFromAccountError')}
            enabled={false}
          />
        </div>
            )

    } else {
      return <LoadingSection />;
    }
  }

  buildPartialForm(step1) {
    if (step1.get('type') === BROKER_REIMBURSE_FUND_PARTIAL) {
      const partialType = step1.get('partialType');
      const partialRadioButtons = this.buildPartialRadioButtons(partialType);
      const partialInput = this.buildPartialInput(step1);

      return (
        <div className="broker-internal-transfer-funds-step1__partial-form">
          {partialRadioButtons}
          <div className="broker-internal-transfer-funds-step1__input-container">
            {partialInput}
          </div>
        </div>
      );
    }
  }

  getPartialOptionsToShow() {
    const { immFlagBasedFeatures, immInvestmentFunds } = this.props;
    const customCategoryId2 = immInvestmentFunds.getIn([
      'steps',
      FIRST_STEP,
      'investmentFunds',
      'customCategoryId2',
    ]);
    const allowFundsPartialReimbursement = immFlagBasedFeatures.get(
      'wealth_funds_partial_reimbursement'
    );

    if (allowFundsPartialReimbursement) {
      return {
        showRadioAmount: SHOW_AMOUNT_AND_PERCENTAGE_RADIO_BUTTON.includes(customCategoryId2),
        showRadioParticipations: SHOW_PARTICIPATIONS_RADIO_BUTTON.includes(customCategoryId2),
        showRadioPercentage: SHOW_AMOUNT_AND_PERCENTAGE_RADIO_BUTTON.includes(customCategoryId2),
      };
    } else {
      return {
        showRadioAmount: true,
        showRadioParticipations: true,
        showRadioPercentage: true,
      };
    }
  }

  buildPartialInput(step1) {
    const { immBrokerInternalTransferFunds, immBrokerMyInvestments, immFunds, immFlagBasedFeatures } = this.props;
    const allowFundsPartialReimbursement = immFlagBasedFeatures.get(
        'wealth_funds_partial_reimbursement'
      );
    const { showRadioParticipations } = this.getPartialOptionsToShow();
    const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
    const partialType = step1.get('partialType');
    const inputValue = step1.get(partialType);
    const inputError = step1.getIn(['errorFlags', partialType]);
    const className = classNames('broker-internal-transfer-funds-step1__input', {
      [`broker-internal-transfer-funds-step1__input--${
        partialType == 'percentage' && !showRadioParticipations ? 'participations' : partialType
      }`]: !!partialType,
    });
    const originFundId = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFund']);
    const originFund = immBrokerMyInvestments
      .getIn(['products', 'funds', 'stocks'], Immutable.fromJS({}))
      .find(fund => fund.get('id') === originFundId);
    const originFundDetails = immFunds.find(
      fund =>
        fund.getIn(['contrato', 'producto']) === originFund.get('product') &&
        fund.getIn(['contrato', 'numerodecontrato']) === originFund.get('numerodecontrato')
    );
    const originParticipations = originFundDetails.get('disponible');
    const maxTransferPercentage = immBrokerMyInvestments.get(
      'maxFundsPartialReimbursementPercentage'
    );
    const originFundCurrency = immBrokerInternalTransferFunds.getIn([
      'steps',
      FIRST_STEP,
      'originFundCurrency',
    ]);
    const aproxAmountParticipations = immBrokerInternalTransferFunds.getIn([
      'steps',
      FIRST_STEP,
      'aproxAmountParticipations',
    ]);
    const lastLiqValue = immBrokerInternalTransferFunds.getIn([
      'steps',
      FIRST_STEP,
      'ultimoValorLiquidativo',
    ]);
    let maxValue;
    let minValue;
    let maxDecimals;
    let maxIntegerLength;
    let errorMessage;
    let hasError;
    let instructionsMessage = '';

    switch (partialType) {
      case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT:
        minValue = BROKER_FUNDS_INTERNAL_TRANSFER_AMOUNT_MINIMUM_VALUE;
        maxValue = BROKER_FUNDS_INTERNAL_TRANSFER_AMOUNT_MAXIMUM_VALUE;
        maxDecimals = BROKER_FUNDS_AMOUNT_DECIMALS;
        maxIntegerLength = BROKER_FUNDS_INTERNAL_TRANSFER_AMOUNT_INTEGER_LENGTH;
        hasError = inputValue <= originFund.get('totalValue') * (maxTransferPercentage / 100);
        instructionsMessage = '';
        errorMessage = hasError ? (
          formatText('brokerReimburseInvestmentStep1-errorImportMessage')
        ) : (
          <FormattedTextWithComponents
            value="brokerInternalTransferFundsStep1-brokerInternalTransferFundsStep1_maxRefundErrorMessageParam"
            injectedComponents={[maxTransferPercentage]}
                />);
                inputError && recordLinkV2({
                    ...brokerTransferFundsTags(fundType, partialType, inputValue, originFundCurrency, true)
                })
        break;
      case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS:
        minValue = BROKER_FUNDS_INTERNAL_TRANSFER_PARTICIPATIONS_MINIMUM_VALUE;
        maxValue = BROKER_FUNDS_INTERNAL_TRANSFER_PARTICIPATIONS_MAXIMUM_VALUE;
        maxDecimals = BROKER_FUNDS_PARTICIPATIONS_DECIMALS;
        maxIntegerLength = BROKER_FUNDS_INTERNAL_TRANSFER_PARTICIPATIONS_INTEGER_LENGTH;
        hasError = inputValue <= originParticipations * (maxTransferPercentage / 100);
        instructionsMessage = allowFundsPartialReimbursement
          ? formatText('brokerReimburseInvestmentStep1-approximateAmount', [
              aproxAmountParticipations,
            ])
          : '';
        errorMessage = hasError ? (
          formatText('brokerReimburseInvestmentStep1-errorParticipationMessage')
        ) : (
          <FormattedTextWithComponents
            value="brokerInternalTransferFundsStep1-brokerInternalTransferFundsStep1_maxRefundErrorMessageParam"
            injectedComponents={[maxTransferPercentage]}
                />);
                inputError && recordLinkV2({
                    ...brokerTransferFundsTags(fundType, partialType, inputValue, originFundCurrency, true)
                })
        break;
      case BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE:
        minValue = BROKER_FUNDS_INTERNAL_TRANSFER_PERCENTAGE_MINIMUM_VALUE;
        maxValue = BROKER_FUNDS_INTERNAL_TRANSFER_PERCENTAGE_MAXIMUM_VALUE;
        maxDecimals = BROKER_FUNDS_PERCENTAGE_DECIMALS;
        maxIntegerLength = BROKER_FUNDS_INTERNAL_TRANSFER_PERCENTAGE_INTEGER_LENGTH;
        hasError = inputValue <= maxTransferPercentage;
        instructionsMessage = '';
        errorMessage = hasError ? (
          formatText('brokerReimburseInvestmentStep1-errorPercentageMessage')
        ) : (
          <FormattedTextWithComponents
            value="brokerInternalTransferFundsStep1-brokerInternalTransferFundsStep1_maxRefundErrorMessageParam"
            injectedComponents={[maxTransferPercentage]}
                />);
                inputError && recordLinkV2({
                    ...brokerTransferFundsTags(fundType, partialType, inputValue, originFundCurrency, true)
                })
        break;
      default:
        minValue = maxValue = maxDecimals = maxIntegerLength = 0;
    }

    return (
      <div className={className}>
        <AmountInput
          amount={inputValue}
          min={minValue}
          max={maxValue}
          callback={value => this.setAmount(value, partialType)}
          onChange={value => this.onChangeAmount(value, partialType)}
          error={inputError}
          errorMsg={errorMessage}
          maxFractionLength={maxDecimals}
          maxIntegerLength={maxIntegerLength}
          maxBackEndFractionLength={maxDecimals}
          keepZeroAndEmpty={true}
          fluid={true}
          language={getLanguage()}
          hideFocusZero
          instructionsMessage={instructionsMessage}
        />
      </div>
    );
  }

  buildPartialRadioButtons(partialType) {
    const { showRadioAmount, showRadioParticipations, showRadioPercentage } =
      this.getPartialOptionsToShow();
    const defaultSelectedOption = (!showRadioAmount && !showRadioPercentage && showRadioParticipations) ? BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS : partialType;
    return (
      <RadioButtonGroup
        name="partialTransfer"
        idPrefix="partialTransferFundsRadio"
        className="broker-internal-transfer-funds-step1__radio-button-group"
        selectedValue={defaultSelectedOption}
        onChange={this.props.onChangePartialTransferType}
      >
        {showRadioAmount && (
          <RadioButton
            value={BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_AMOUNT}
            label={formatText('brokerInternalTransferFund-partialAmount')}
            className="broker-internal-transfer-funds-step1__partial-radio-button broker-internal-transfer-funds-step1__partial-radio-button--first"
          />
        )}
        {showRadioParticipations && (
          <RadioButton
            value={BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PARTICIPATIONS}
            label={formatText('brokerInternalTransferFund-partialParticipations')}
            className="broker-internal-transfer-funds-step1__partial-radio-button broker-internal-transfer-funds-step1__partial-radio-button--middle"
          />
        )}
        {showRadioPercentage && (
          <RadioButton
            value={BROKER_PARTIAL_TRANSFER_TYPE_FUNDS_PERCENTAGE}
            label={formatText('brokerInternalTransferFund-partialPercentage')}
            className="broker-internal-transfer-funds-step1__partial-radio-button"
          />
        )}
      </RadioButtonGroup>
    );
  }

  buildRadioButtons() {
    const { immBrokerInternalTransferFunds } = this.props;
    const type = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'type']);
    return (
      <RadioButtonGroup
        name="motive"
        idPrefix="cancelChequebookMotiveRadio"
        className="broker-internal-transfer-funds-step1__radio-button-group"
        selectedValue={type}
        onChange={this.props.onChangeType}
      >
        <RadioButton
          value={BROKER_REIMBURSE_FUND_TOTAL}
          label={formatText('brokerInternalTransferFund-total')}
          className="broker-internal-transfer-funds-step1__radio-button-yes"
        />
        <RadioButton
          value={BROKER_REIMBURSE_FUND_PARTIAL}
          label={formatText('brokerInternalTransferFund-partial')}
          className="broker-internal-transfer-funds-step1__radio-button-no"
        />
      </RadioButtonGroup>
        )
  }

  buildExAnteDisclaimers() {
    const dataProtectionLink = (
      <OKLink
        modifier="emphasize"
        target="_blank"
                to={formatText(
                    "brokerInternalTransferFund-exAnteDisclaimer1linkUrl"
                )}
      >
        <FormattedText value="brokerInternalTransferFund-exAnteDisclaimer1linkText" />
      </OKLink>
    );
    return (
      <div>
        <OKMessage>
          <FormattedTextWithComponents
            value="brokerInternalTransferFund-exAnteDisclaimer1"
            injectedComponents={[dataProtectionLink]}
          />
        </OKMessage>
        <OKMessage>
          <FormattedText value="brokerInternalTransferFund-exAnteDisclaimer2" />
        </OKMessage>
      </div>
    );
  }

  render() {
    const { immBrokerInternalTransferFunds, immFlagBasedFeatures, immInvestmentFunds } = this.props;
    const immStep1 = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP]);
    const title = formatText('brokerInternalTransferFund-title');
    const originFundContainer = this.buildOriginFoundContainer();
    const destinationFund = this.buildDestinationFundContainer();
    const originFundDetails = this.buildDetails('originFund');
    const destinationFundDetails = this.buildDetails('destinationFund');
    const radioButtons = this.buildRadioButtons();
    const partialForm = this.buildPartialForm(immStep1);
    const fundSecId = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'secId']);
        const exAnteDisclaimers = immFlagBasedFeatures.get(
            'wealth_funds_transfer_show_costs'
        )
      ? this.buildExAnteDisclaimers()
      : null;
    if (!fundSecId) {
            return <LoadingSection/>;
    }
    return (
      <div className="broker-internal-transfer-funds-step1">
        <header className="broker-internal-transfer-funds-step1__header">
                    <h2 className="broker-internal-transfer-funds-step1__title">
                        {title}
                    </h2>
        </header>
                <FormattedText value="brokerInternalTransferFund-details" className="broker-internal-transfer-funds-step1__details"/>
                <FormattedText value="brokerInternalTransferFund-origin" className="broker-internal-transfer-funds-step1__origin broker-internal-transfer-funds-step1__inline"/>
                <OKTooltip
                    content="brokerInternalTransferFund-originTooltip"
                    offset={[0, -15]}
                />
        {originFundContainer}
        {originFundDetails}
                <FormattedText value="brokerInternalTransferFund-destination" className="broker-internal-transfer-funds-step1__destination broker-internal-transfer-funds-step1__inline"/>
                <OKTooltip
                    content="brokerInternalTransferFund-destinationTooltip"
                    offset={[0, -15]}
                />
        {destinationFund}
        {destinationFundDetails}
                <FormattedText value="brokerInternalTransferFund-typeDesc" className="broker-internal-transfer-funds-step1__type-desc"/>
                <FormattedText value="brokerInternalTransferFund-type" className="broker-internal-transfer-funds-step1__type broker-internal-transfer-funds-step1__inline"/>
                <OKTooltip
                    content="brokerInternalTransferFund-transferTypeTooltip"
                    offset={[0, -15]}
                />
        {radioButtons}

                <div className="broker-internal-transfer-funds-step1__partial-container">
                    {partialForm}
                </div>
        {exAnteDisclaimers}
      </div>
    );
  }
}

BrokerInternalTransferFundsStep1.propTypes = {
  immAccounts: PropTypes.object,
  onSetAmount: PropTypes.func,
  onChangeType: PropTypes.func.isRequired,
  immBrokerMyInvestments: PropTypes.object.isRequired,
  immFlagBasedFeatures: PropTypes.object.isRequired,
  immDestinationFunds: PropTypes.object.isRequired,
  immBrokerInternalTransferFunds: PropTypes.object.isRequired,
  immInvestmentFunds: PropTypes.object.isRequired,
  handleOnOriginFundChange: PropTypes.func.isRequired,
  handleSetDestinationFund: PropTypes.func.isRequired,
  immFunds: PropTypes.object.isRequired,
  immBrokerMiFIDProducts: PropTypes.object.isRequired,
  onChangePartialTransferType: PropTypes.func.isRequired,
  onFetchBrokerMiFIDProduct: PropTypes.func.isRequired,
  getMorningStarScreener: PropTypes.func.isRequired,
  setAproxAmountParticipations: PropTypes.func,
};

module.exports = BrokerInternalTransferFundsStep1;
